import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import SimpleDataTables from '../Common/SimpleDataTables';
import { getProductsInStockAction } from '../../redux/actions/admin/AdminAction';

const GetProductsInStock = ({ products, getProductsInStockAction }) => {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if(products && products.length === 0) {
            getProductsInStockAction();
        }
        setRows(products);
    }, [products]);

    const columns = [
        {
            label: 'Product Id',
            field: 'productId',
        },
        {
            label: 'Name',
            field: 'productName',
        },
        {
            label: 'Description',
            field: 'productDescription',
        },
        {
            label: 'Category',
            field: 'productType',
        },
        {
            label: 'Quantity',
            field: 'productQuantity',
        },
        {
            label: 'Date added',
            field: 'date',
        }
    ];

    return (
        <div className='container'>
            <div className='row my-2'>
                <div className='col-md-10 display-4 mb-4'>Available Products in Stock</div>
                <div className='col-md-2 mb-4 mt-2'>
                    <Link to='/admin' className='btn btn-sm btn-secondary'><FontAwesomeIcon className='FntIcon' key={1} icon={faArrowLeft} />&nbsp; &nbsp; Go Back</Link>
                </div>
            </div>
            {rows && rows.length === 0 ?
                (
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-grow text-primary" role="status">
                            </div>
                        </div>
                        <p className="text-center">Loading...</p>
                    </>
                ) :
                <SimpleDataTables columns={columns} rows={rows} />
            }
        </div>
    );
};

GetProductsInStock.propTypes = {
    products: PropTypes.array.isRequired,
    getProductsInStockAction: PropTypes.func.isRequired
};

GetProductsInStock.defaultProps = {
    products: []
};

const mapStateToProps = (state) => {
    return {
        products: state.admins
    };
};

const mapDispatchToProps = {
    getProductsInStockAction
};

export default connect(mapStateToProps, mapDispatchToProps)(GetProductsInStock);